import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CallbackWrapperService, FormControlRerenderSubject } from 'projects/login/src/app/services/callback-wrapper.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  template: '',
})
export abstract class NgControlBaseComponent implements OnInit, OnDestroy {
  pendingSubject: Subject<NgControl> = new Subject<NgControl>();
  private destroy$: Subject<boolean> = new Subject<boolean>();

  protected constructor(
    protected readonly cdRef: ChangeDetectorRef,
    protected readonly callbackService: CallbackWrapperService,
    protected ngControl?: NgControl | null,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.callbackService
      .getSubject(FormControlRerenderSubject)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.setPending();
      });

    this.ngControl?.valueChanges?.subscribe({
      next: (value) => {
        // Don't trigger changes when the value was undefined or the same as the previous value
        if (this.ngControl?.value === value) {
          return;
        }
        this.setPending();
      },
    });
  }

  setPending() {
    if (!this.ngControl) {
      return;
    }

    this.ngControl.control?.markAsTouched();
    this.cdRef.markForCheck();
    this.pendingSubject.next(this.ngControl);
  }
}
